<template>
    <nav aria-label="Page navigation">
        <ul class="pagination justify-content-center">
            <li class="page-item" :class="{ disabled: CurrentPage === 1 }">
                <a class="page-link" href="#" @click.prevent="changePage(CurrentPage - 1)">‹ Previous</a>
            </li>
            <!-- First Page -->
            <template v-if="CurrentPage !== 1">
                <li class="page-item" :class="{ active: CurrentPage === 1 }">
                    <a class="page-link" href="#" @click.prevent="changePage(1)">1</a>
                </li>
            </template>
            <!-- Ellipses if needed -->
            <li v-if="CurrentPage > 4" class="page-item disabled"><span class="page-link">...</span></li>
            <!-- Page Numbers around Current Page -->
            <li v-for="page in visiblePages" :key="page" class="page-item" :class="{ active: page === CurrentPage }">
                <a class="page-link" href="#" @click.prevent="changePage(page)">{{ page }}</a>
            </li>
            <!-- Ellipses if needed -->
            <li v-if="CurrentPage < totalPages - 3" class="page-item disabled"><span class="page-link">...</span></li>
            <!-- Last Page -->
            <template v-if="CurrentPage !== totalPages">
                <li class="page-item" :class="{ active: CurrentPage === totalPages }">
                    <a class="page-link" href="#" @click.prevent="changePage(totalPages)">{{ totalPages }}</a>
                </li>
            </template>
            <li class="page-item" :class="{ disabled: CurrentPage === totalPages }">
                <a class="page-link" href="#" @click.prevent="changePage(CurrentPage + 1)">Next ›</a>
            </li>
        </ul>
        <!-- <div class="pagination-info">
            <span>Page {{ CurrentPage }} of {{ totalPages }}</span>
        </div> -->
    </nav>
</template>

<script>
export default {
    name: 'Pagination',
    props: {
        CurrentPage: {
            type: Number,
            required: true
        },
        totalPages: {
            type: Number,
            required: true
        },
        perPage: {
            type: Number,
            required: true
        },
        totalRecords: {
            type: Number,
            required: true
        }
    },
    computed: {
        visiblePages() {
            const range = 2;
            let pages = [];
            for (let i = Math.max(2, this.CurrentPage - range); i < this.CurrentPage; i++) {
                pages.push(i);
            }
            pages.push(this.CurrentPage);
            for (let i = this.CurrentPage + 1; i <= Math.min(this.totalPages - 1, this.CurrentPage + range); i++) {
                pages.push(i);
            }
            return pages;
        }
    },
    methods: {
        changePage(page) {
            if (page < 1) {
                this.$emit('page-change', 1);
            } else if (page > this.totalPages) {
                this.$emit('page-change', this.totalPages);
            } else {
                this.$emit('page-change', page);
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/partials/Pagination.vue